// import Vue from 'vue'
import { Component } from "vue-property-decorator";
import { UserLoginModel, UserLoggedInfoModel } from "@/models/userModels";
import { mapActions } from "vuex";
import axios, { AxiosPromise } from "axios";
import baseContextComponent from "@/components/baseContextComponent";
import api from "@/services/api";

@Component({
	methods: { ...mapActions(["loginUser"]) }
})
export default class loginPage extends baseContextComponent {
	isLoading: boolean = false;
	user: UserLoginModel = new UserLoginModel();
	loginUser!: (token: any) => Promise<UserLoggedInfoModel>;
	emailRules = [
		(v: string) => {
			return !!v || "Campo obbligatorio";
		},
		(v: string | null) =>
			v == null || /.+@.+/.test(v) || "Formato non valido"
	];
	passwordRules = [(v: string | null) => !!v || "Campo obbligatorio"];

	checkForm(e: any) {
		var instance = this;
		e.preventDefault();
		instance.isLoading = true;
		api.doJwtLogin(instance.user)
			.then(token => {
				let path = instance.$route.query.returnUrl || "/";
				instance.loginUser(token).then(() => {
					instance.$router.push({ path: path as string });
				});
				instance.isLoading = false;
			})
			.catch(error => {
				console.error(error);
				instance.isLoading = false;
			});
	}
}
